function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "71-Graph-Arrow up"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30,2H20V1a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1V2H2A2,2,0,0,0,0,4V24a2,2,0,0,0,2,2H8.59L4.29,30.29l1.41,1.41L11.41,26H15v6h2V26h3.59l5.71,5.71,1.41-1.41L23.41,26H30a2,2,0,0,0,2-2V4A2,2,0,0,0,30,2Zm0,22H2V4H30Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.59,13H13a1,1,0,0,0-.71.29l-6,6,1.41,1.41L13.41,15H19a1,1,0,0,0,.71-.29L24,10.41V13h2V8a1,1,0,0,0-1-1H20V9h2.59Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("text", {
  x: 0,
  y: 47,
  fill: "#000000",
  fontSize: "5px",
  fontWeight: "bold",
  fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
}, "Created by Iconstock");

var _ref4 = /*#__PURE__*/React.createElement("text", {
  x: 0,
  y: 52,
  fill: "#000000",
  fontSize: "5px",
  fontWeight: "bold",
  fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
}, "from the Noun Project");

var SvgReports = function SvgReports(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#8E8B99",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReports, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reports.05148ecf.svg";
export { ForwardRef as ReactComponent };